'use client';

import { Container } from '@/components/ui/Container';

export default function PrivacyPolicyPage() {
  return (
    <Container>
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        <div className="prose prose-slate max-w-none">
          <p>This Privacy Policy explains how bdNOG collects, uses, shares, and protects your information.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">1. Information We Collect</h2>
          <p>We may collect the following types of personal information:</p>
          <ul>
            <li>Name</li>
            <li>Contact information (including email address, mailing address, and phone number)</li>
            <li>Payment details</li>
            <li>Demographic information</li>
            <li>Preferences and interests</li>
          </ul>
          <p>We collect this information when you:</p>
          <ul>
            <li>Register or create an account on our website</li>
            <li>Make a payment</li>
            <li>Sign up for events</li>
            <li>Contact our secretariat</li>
            <li>Interact with our website through cookies or similar technologies</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">2. How We Use Your Information</h2>
          <p>We use the collected information for purposes including:</p>
          <ul>
            <li>Processing registrations and payments</li>
            <li>Providing and personalizing services</li>
            <li>Improving our programs, events and overall experience</li>
            <li>Sending important updates</li>
            <li>Communicating with you regarding your account or general inquiries</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">3. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Service Providers – to help operate our website and services.</li>
            <li>Legal Authorities – if required by law, regulation, or to protect our legal rights.</li>
          </ul>
          <p>We do not sell or rent your personal information to third parties.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">4. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to safeguard your information. However, please note that no online transmission or electronic storage method is completely secure.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access, correct, or delete your personal information</li>
            <li>Object to or restrict certain data processing activities</li>
            <li>Opt out of receiving marketing communications at any time</li>
          </ul>
          <p>To exercise these rights, please contact us using the information provided below.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">6. Cookies</h2>
          <p>Our website uses cookies and similar technologies to enhance your browsing experience and analyze website traffic. You can manage or disable cookies through your browser settings. Some website features may not function properly without cookies.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">7. Changes to This Privacy Policy</h2>
          <p>We may update or modify this Privacy Policy from time to time. Any changes will become effective immediately upon posting the revised policy on our website.</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">8. Contact Us</h2>
          <p>If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us:</p>
          <p className="mt-4">
            bdNOG<br />
            Email: secretariat@bdnog.org<br />
            Website: www.bdnog.org
          </p>

          <p className="mt-6 text-sm text-gray-500">Last Updated: 22.10.2025</p>
        </div>
      </div>
    </Container>
  );
}
